// eslint-disable-next-line no-use-before-define
import React from 'react';
import { ChannelProvider, useChannelContext } from '@sendbird/uikit-react/Channel/context';
import ChannelUI from '@sendbird/uikit-react/Channel/components/ChannelUI';
import { VueInReact } from 'vuera-ts';
import { MessageMetaArray } from '@sendbird/chat/message';
import ChannelHeader from './ChannelHeader.vue';
import { addChannelAccessibility } from '../../js/addAccessibility';
import { getOtherUserInformation } from '../../js/getOtherUserInformation';
import { formatAdminMessages } from '../../js/formatAdminMessages';
import { readMeta } from '../../../../lib/page';
import useMediaQuery from '../../js/useMediaQuery.js';
import ConversationNotFound from './ConversationNotFound.vue';

const ChannelHeaderReact = VueInReact(ChannelHeader);
const ConversationNotFoundReact = VueInReact(ConversationNotFound);

const CustomChannelUI = ({ currentChannelMembers, userId, accountType, currentChannelUrl, onBackClick }) => {
  const otherUserInfo = getOtherUserInformation(currentChannelMembers, userId);

  const { loading, allMessages } = useChannelContext();
  if (!loading) {
    addChannelAccessibility();
    formatAdminMessages(allMessages, otherUserInfo, accountType);
  }

  return (
    <ChannelUI
      renderChannelHeader={() => (
        <ChannelHeaderReact
          otherUserInformation={otherUserInfo}
          accountType={accountType}
          currentChannelUrl={currentChannelUrl}
          onBackClick={onBackClick}
        />
      )}
      renderMessage={otherUserInfo.showMessageHistory ? null : () => <></>}
      renderCustomSeparator={otherUserInfo.showMessageHistory ? null : () => <></>}
      renderMessageInput={otherUserInfo.showTrustSafetyBanner ? () => <></> : null}
    />
  );
};

const ChannelWrapper = ({
  currentChannelUrl,
  currentChannelMembers,
  userId,
  accountType,
  onBackClick,
  hasBasicAccount,
  queryParamChannelNotFound,
}) => {
  const disableSendFileMessage = () => {};
  const mobile = useMediaQuery('(max-width: 767px)');

  return (
    <div className="sendbird-app__conversation-wrap">
      {currentChannelUrl && !hasBasicAccount ? (
        <ChannelProvider
          channelUrl={currentChannelUrl}
          isReactionEnabled={false}
          onBeforeSendFileMessage={disableSendFileMessage}
          onBeforeSendUserMessage={(message) => {
            const userMessageParams = {
              message,
              metaArrays: [
                new MessageMetaArray({
                  key: 'session',
                  value: [readMeta('session')],
                }),
              ],
            };

            return userMessageParams;
          }}
        >
          <CustomChannelUI
            currentChannelMembers={currentChannelMembers}
            userId={userId}
            accountType={accountType}
            onBackClick={onBackClick}
            currentChannelUrl={currentChannelUrl}
          />
        </ChannelProvider>
      ) : (
        <div className="h-full bg-grey-background-subdued border-1 border-solid border-grey-divider-subdued">
          {queryParamChannelNotFound && <ConversationNotFoundReact onBackClick={onBackClick} mobile={mobile} />}
        </div>
      )}
    </div>
  );
};

export default ChannelWrapper;
